import { ArrowLeftIcon } from 'components/Icons'
import { BackLink, TitleLine, TitleWrapper } from './styles'

interface IProps {
  title: string,
  backlink?: string,
}

const Title = (props: IProps) =>
  <TitleWrapper>
    <TitleLine>
      {props.backlink && <BackLink to={props.backlink}><ArrowLeftIcon /></BackLink>}
      {props.title}
    </TitleLine>
  </TitleWrapper>

export default Title
